import React from "react";

const SelectDocument = ({
  setScreen,
  country,
  document,
  setDocument,
  setGovNumber,
  govNumber,
}: any) => {
  const documentList = [
    { id: 1, name: "Digital NIN Slip" },
    { id: 2, name: "NIN ID Card" },
    { id: 3, name: "NIN Slip" },
    { id: 4, name: "Voter's Card" },
    { id: 5, name: "Passport" },
  ];

  return (
    <div className="w-full font-manrope">
      {/* Progress Steps */}
      <div className="flex w-full gap-2 justify-start items-center">
        <div className="w-[24px] h-[24px] rounded-full border-[0.5px] border-[#0B75C2] bg-[#E9F1FF]  font-sora text-secondary_button text-[10px] flex justify-center items-center">
          1
        </div>
        <h4 className="text-[12px] text-black dark:text-white font-sora font-bold">
          Govt ID
        </h4>
        <div className="bg-[#E5E7EB] dark:bg-gray-500 w-[2px] h-4 rounded-full"></div>
        <div className="w-[24px] h-[24px] rounded-full bg-[#EBEBEB] font-sora text-gray-600 dark:text-gray-400 dark:bg-gray-600 text-[10px] flex justify-center items-center">
          2
        </div>
        <div className="w-[24px] h-[24px] rounded-full bg-[#EBEBEB] font-sora text-gray-600 dark:text-gray-400 dark:bg-gray-600 text-[10px] flex justify-center items-center">
          3
        </div>
      </div>

      {/* Title */}
      <div className="w-full mt-10">
        <h4 className="text-black dark:text-white text-center font-semibold font-sora text-[16px]">
          Select a document to verify
        </h4>
        <h4 className="text-gray-400 text-center font-medium text-[12px]">
          Country: {country}
        </h4>

        {/* Document Selection */}
        <div className="mt-6 w-full">
          {documentList.map((doc) => (
            <div key={doc.id} className="w-full flex flex-col gap-1">
              <div className="flex items-center gap-3 py-2">
                <input
                  type="radio"
                  value={doc.name}
                  checked={document === doc.name}
                  onChange={(e) => setDocument(e.target.value)}
                  className="w-[14px] h-[14px] rounded-full bg-transparent"
                />
                <h4 className="text-gray-500 dark:text-gray-400 text-[18px]">
                  {doc.name}
                </h4>
              </div>
              {document === doc.name && (
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  placeholder={`Enter your ${doc.name} number`}
                  value={govNumber}
                  onChange={(e) =>
                    setGovNumber(e.target.value.replace(/\D/g, ""))
                  }
                  className="w-full dark:bg-[#1F2B36] dark:text-gray-300 text-gray-700 border-gray-300 dark:border-gray-600 h-[48px] mt-2 mb-2 outline-none text-[15px] border bg-[#F7F8F9] px-4 rounded-xl"
                />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Next Button */}
      <button
        disabled={!document || !govNumber}
        onClick={() => setScreen(3)}
        className={
          !document || !govNumber
            ? "w-full h-[52px] flex justify-center text-[15px] items-center mt-8 font-semibold text-gray-200 rounded-xl bg-gray-400"
            : "w-full h-[52px] flex justify-center text-[15px] items-center mt-8 font-semibold text-white rounded-xl bg-secondary_button"
        }
      >
        Next
      </button>
    </div>
  );
};

export default SelectDocument;
